import { RootState, store } from "store";
import { sandboxActionInvoked } from "store/features";
import { SvgDelete } from "@itwin/itwinui-icons-react";
import { MenuItem } from "@itwin/itwinui-react";

export const DeleteMenuItem = ({ close }: { close: () => void }) => {
  const state = store.getState() as RootState;
  const metadata = state.activeSandbox.metadata;
  const user = state.auth.user;

  const onClick = () => {
    if (metadata)
      store.dispatch(sandboxActionInvoked({
        type: "delete",
        args: {
          sandboxId: metadata.id,
          userId: metadata.userId,
          redirect: "/sandboxes"
        }
      }));

    close();
  }

  return (
    <MenuItem
      icon={<SvgDelete />}
      onClick={onClick}
      disabled={!(metadata && user && metadata.userId === user.id)}
      data-testid="atp-delete-sandbox"
    >
      Delete
    </MenuItem>
  )
}
